import { render, staticRenderFns } from "./FiltroNumber.vue?vue&type=template&id=1a3657c9&"
import script from "./FiltroNumber.vue?vue&type=script&lang=ts&"
export * from "./FiltroNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports